import React from "react";
import cx from "classnames";
import { ChevronLeftIcon, ChevronRightIcon } from "assets";
import { useTranslation } from "i18n";
import ProfileButton from "pages/Profile/components/common/ProfileButton";
import "./styles.scss";

interface Props {
  direction: "prev" | "next";
  className?: string;
  onClick?: () => void;
}

const SlideButton = ({ onClick, direction, className }: Props) => {
  const { t } = useTranslation();

  return (
    <ProfileButton
      className={cx("slide-button", className)}
      onClick={onClick}
      aria-label={
        direction === "prev"
          ? t("common:aria.label.previousSlide")
          : t("common:aria.label.nextSlide")
      }
    >
      {direction === "prev" ? (
        <ChevronLeftIcon aria-hidden="true" focusable="false" />
      ) : (
        <ChevronRightIcon aria-hidden="true" focusable="false" />
      )}
    </ProfileButton>
  );
};

export default SlideButton;
